/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

// A wrapper around localStorage that's not susceptible to its errors.
// If local storage isn't available, it falls back to NanoCookie.
// If you need session storage, consider using PageState!

import { NanoCookie } from "legacy/Cookies";

window.Storage = {
	init() {
		return (this.useLocalStorage = Modernizr.localstorage);
	},

	getItem(key) {
		if (this.useLocalStorage) {
			return localStorage.getItem(key);
		} else {
			return NanoCookie.get(key);
		}
	},

	setItem(key, value) {
		if (this.useLocalStorage) {
			return localStorage.setItem(key, value);
		} else {
			return NanoCookie.set(key, value, { ms: 86400 * 1000 });
		}
	},

	removeItem(key) {
		if (this.useLocalStorage) {
			return localStorage.removeItem(key);
		} else {
			return NanoCookie.remove(key, value);
		}
	},
};

Storage.init();



// WEBPACK FOOTER //
// ./src/legacy/storage.js